import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import { DatasourceMeta, EDIPHI_DATASOURCE_META } from "../datasources/meta";
import type { ReportGroup } from "../../../excel/reports/api/groups";

/**
 * Label and icon per report group. The three shared groups reference the datasource record rather
 * than redeclaring, so the two pages can't drift. `other` has no datasource counterpart.
 */
export const REPORT_GROUP_META: Record<ReportGroup, DatasourceMeta> = {
  estimate: EDIPHI_DATASOURCE_META.estimate,
  gcgr: EDIPHI_DATASOURCE_META.gcgr,
  contracting: EDIPHI_DATASOURCE_META.contracting,
  other: { label: "Other", icon: WidgetsOutlinedIcon },
};
